import { render, staticRenderFns } from "./DiagnosticDetails.vue?vue&type=template&id=1f25011a&scoped=true"
import script from "./DiagnosticDetails.vue?vue&type=script&lang=js"
export * from "./DiagnosticDetails.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticDetails.vue?vue&type=style&index=0&id=1f25011a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25011a",
  null
  
)

export default component.exports